import { render, staticRenderFns } from "./wizard.vue?vue&type=template&id=d07a3ed2&scoped=true&"
import script from "./wizard.vue?vue&type=script&lang=js&"
export * from "./wizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07a3ed2",
  null
  
)

export default component.exports